export default __webpack_public_path__ + "static/media/newborn.8429525a.jpg";